const setToEmpty = (obj) => {
  for (let key in obj) {
    if (!(key == 'endData' || key == 'endTime' || key == 'endDataFR' || key == 'endTimeFR')) {
      obj[key] = '';
    }
  }
  return obj;
};

let MyPlugin = {};

MyPlugin.install = function (Vue, options) {
  // 1. 添加全局方法或属性
  // 过滤时间戳
  Vue.filter('formatTime', (val) => {
    return new Date(val).Format("yyyy-MM-dd hh:mm:ss");
  });
  Vue.filter('formatDescr', (val) => {
    if (val) {
      let str = '';
      let descArr = val.split('|');
      descArr.forEach((val, ind) => {
        let item = val.split(',');
        str += `第${ind + 1}条工单: 车牌: ${item[0]} `;
        if (item[1]) {
          str += `盒子: ${item[1]} `;
        }

        if (item[2]) {
          str += `新车牌: ${item[2]} `;
        }

        if (item[3]) {
          str += `新盒子: ${item[3]} `;
        }
      })
      return str;
    } else {
      return '';
    }
  });
  Vue.filter('formatType', (val, list) => {
    let type = '';
    if (list.length) {
      list.forEach(item => {
        if (val == item.type) {
          type = item.descr;
        }
      })
    }
    return type;
  });

  Vue.prototype.setToEmpty = setToEmpty;
};

export default MyPlugin;



// WEBPACK FOOTER //
// ./src/plugins/plugin.js